import { Component } from "../components/index"
import { qsa, qs } from "../utils/index"
import gsap from "gsap"

export default class Dropdown extends Component {
  constructor(obj) {
    super(obj)

    this.tabs = qsa(".dropdown-tab", this.el)
    this.content = qsa(".dropdown-text", this.el)
    this.smooth = obj.renderer.smooth || false
  }

  setup() {
    this.content.forEach(item => {
      gsap.set(item, { height: "0" })
      item.setAttribute("aria-expanded", "false")
      this.smooth?.update()
    })
  }

  toggleDrodown(e) {
    const target = e.currentTarget
    const content = target.nextElementSibling
    const plus = qs(".plus", target)
    const minus = qs(".minus", target)
    const isOpen = content.getAttribute("aria-expanded") === "true"

    if (isOpen) {
      content.setAttribute("aria-expanded", "false")
      gsap.to(content, {
        height: 0,
        duration: 0.3,
        ease: "power2.inOut",
        onComplete: () => {
          this.smooth?.update()
        },
      })
      gsap.to(plus, { autoAlpha: 1, duration: 0.2 })
      gsap.to(minus, { autoAlpha: 0, duration: 0.2 })
    } else {
      content.setAttribute("aria-expanded", "true")
      gsap.to(content, {
        height: "auto",
        duration: 0.3,
        ease: "power2.inOut",
        onComplete: () => {
          this.smooth?.update()
        },
      })
      gsap.to(plus, { autoAlpha: 0, duration: 0.2 })
      gsap.to(minus, { autoAlpha: 1, duration: 0.2 })
    }
  }

  on() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", e => this.toggleDrodown(e))
    })
  }
}
